(() => {
  if (window.ksHideCollectionStockNotifyV2Initialized) return;
  window.ksHideCollectionStockNotifyV2Initialized = true;

  const MOBILE_QUERY = '(max-width: 767px)';
  const CARD_SELECTOR =
    '.facest-filters-section .ks-collection-product-card.m-product-card--soldout';
  const HIDDEN_ATTR = 'data-ks-collection-notify-hidden';
  let scanFrame = null;

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[„”"'’`!?.:,;()]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const isNotifyText = (value) => {
    const text = normalize(value);
    if (!text || text.length > 90) return false;

    return (
      text === 'anunta ma' ||
      text.includes('anunta ma cand revine in stoc') ||
      text.includes('anunta ma cand revine')
    );
  };

  const markHidden = (element) => {
    if (!element || element.hasAttribute(HIDDEN_ATTR)) return;
    element.setAttribute(HIDDEN_ATTR, 'true');
    element.hidden = true;
  };

  const hideNotifyControl = (card, element) => {
    const control =
      element.closest('button, a, [role="button"], [onclick]') || element;

    if (!card.contains(control)) return;
    markHidden(control);

    let wrapper = control.parentElement;
    let depth = 0;

    while (wrapper && wrapper !== card && depth < 4) {
      if (
        wrapper.matches(
          '.m-product-card__media, .m-product-card__content, .m-product-card__info'
        )
      ) {
        break;
      }

      const wrapperText = wrapper.textContent;
      const hasProductContent = wrapper.querySelector(
        'img, responsive-image, .m-product-card__main-image, .m-product-card__name, .m-product-card__price, .ks-card-wishlist'
      );

      if (isNotifyText(wrapperText) && !hasProductContent) {
        markHidden(wrapper);
        wrapper = wrapper.parentElement;
        depth += 1;
        continue;
      }

      break;
    }
  };

  const cleanOldFailedClasses = (card) => {
    card
      .querySelectorAll(
        '.ks-stock-notify-shell, .ks-compact-stock-notify, .ks-stock-notify-text-replaced'
      )
      .forEach((element) => {
        element.classList.remove(
          'ks-stock-notify-shell',
          'ks-compact-stock-notify',
          'ks-stock-notify-text-replaced'
        );
        element.removeAttribute('data-ks-stock-label');
      });
  };

  const processCard = (card) => {
    cleanOldFailedClasses(card);

    const candidates = Array.from(
      card.querySelectorAll('button, a, [role="button"], [onclick], div, span, p')
    ).filter((element) => isNotifyText(element.textContent));

    const leafCandidates = candidates.filter(
      (element) =>
        !Array.from(element.children).some((child) =>
          isNotifyText(child.textContent)
        )
    );

    leafCandidates.forEach((element) => hideNotifyControl(card, element));
  };

  const restoreDesktop = () => {
    document
      .querySelectorAll(`[${HIDDEN_ATTR}="true"]`)
      .forEach((element) => {
        element.hidden = false;
        element.removeAttribute(HIDDEN_ATTR);
      });
  };

  const scan = () => {
    scanFrame = null;

    if (!window.matchMedia(MOBILE_QUERY).matches) {
      restoreDesktop();
      return;
    }

    document.querySelectorAll(CARD_SELECTOR).forEach(processCard);
  };

  const scheduleScan = () => {
    if (scanFrame) return;
    scanFrame = window.requestAnimationFrame(scan);
  };

  const start = () => {
    scheduleScan();

    const observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.setTimeout(scheduleScan, 300);
    window.setTimeout(scheduleScan, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('resize', scheduleScan, { passive: true });
  document.addEventListener('shopify:section:load', scheduleScan);
})();
